import React, { createContext, useContext, useState, useEffect } from 'react';

const YearContext = createContext();

export const useYear = () => {
  const context = useContext(YearContext);
  if (!context) {
    throw new Error('useYear must be used within a YearProvider');
  }
  return context;
};

export const YearProvider = ({ children }) => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [showAllYears, setShowAllYears] = useState(false);

  // Load from localStorage on mount
  useEffect(() => {
    const savedYear = localStorage.getItem('selectedYear');
    const savedShowAll = localStorage.getItem('showAllYears');
    if (savedYear) {
      setSelectedYear(parseInt(savedYear));
    }
    if (savedShowAll === 'true') {
      setShowAllYears(true);
    }
  }, []);

  // Save to localStorage when changed
  useEffect(() => {
    localStorage.setItem('selectedYear', selectedYear.toString());
  }, [selectedYear]);

  useEffect(() => {
    localStorage.setItem('showAllYears', showAllYears.toString());
  }, [showAllYears]);

  const value = {
    selectedYear,
    setSelectedYear,
    showAllYears,
    setShowAllYears,
    currentYear,
  };

  return <YearContext.Provider value={value}>{children}</YearContext.Provider>;
};

